<template>
  <DBox
    :id="'cmp-royalty-royalty_accounts-sidewindow-contract_list'"
    :addButton="false"
    :addLink="false"
    :leftMenu="
      !selectedAccountDetails.mechanical_rates_empty
        ? [
            { text: '+ '+$t('add_new_contract'), value: 'add_contract_form' },
            { text: '+ '+$t('add_new_us_mechanical'), value: 'harry_fox_contract_form' },
          ]
        : [{ text: '+ '+$t('add_new_contract'), value: 'add_contract_form' }]
    "
    @menuClick="menuClick"
  >
    <NTable
      class="dbox1"
      id="royalty-royalty_accounts-sidewindow-contract_list"
      :config="tableConfig"
      :headers="headers"
      :items="list"
      :showNoItems="false"
    >
      <template v-slot:item="{ item, tdcon }">
        <tr>
          <td v-bind="tdcon('contract_name')">
            <div class="contact_status">
              <span
              :title="item['label_status_name']"
                class="circle-status"
                :style="{
                  backgroundColor: `#${item['label_status_colour']}`,
                }"
              ></span>
              <span
                @click.stop="(e) => onSelectContract(item)"
                class="txtov ut-link ut-text-accent5 contract_name_text"
                :title="item['contract_name']"
              >
                {{ item["contract_name"] }}
              </span>
            </div>
          </td>
          <!-- <td v-bind="tdcon('contract_ref')">
            <span class="txtov" :title="item['contract_ref']">
              {{ item["contract_ref"] }}
            </span>
          </td>
          <td v-bind="tdcon('id_prod')">
            <span class="txtov" :title="item['id_prod']">
              {{ item["id_prod"] }}
            </span>
          </td>
          <td v-bind="tdcon('cost_center')">
            <span class="txtov" :title="item['cost_center']">
              {{ item["cost_center"] }}
            </span>
          </td> -->
          <!-- <td v-bind="tdcon('contract_type')">
            <span class="txtov" :title="item['contract_type']">
              {{ item["contract_type"] }}
            </span>
          </td> -->
          <td v-bind="tdcon('royalties')">
            <span class="txtov" :title="item['royalties']">
              {{ item["royalties"] }}
            </span>
          </td>
          <td v-bind="tdcon('catalog_no')">
            <span class="txtov" :title="item['catalog_nos_comma']">
              {{ item["catalog_nos_comma"] }}
            </span>
          </td>
          <td v-bind="tdcon('royalty_types')">
            <div
              v-if="item['mechanical_flag'] == 1"
              style="display: flex; margin: 0 auto"
            >
              <img
                src="static/icons/royalty/mechanical-contract.svg"
                class="dt-icon v5 s2"
                alt="Digital"
                title="Digital"
                
              

              />
            </div>
            <div v-else style="display: flex">
              <img
                src="static/icons/royalty/icon-digital.svg"
                class="dt-icon v5 s2"
                alt="Digital"
                title="Digital"
                :style="{
                  opacity:
                    item['royalty_types'] &&
                    item['royalty_types'].split(',').includes('digital')
                      ? '1'
                      : '0.2',
                }"
              />

              <img
                src="static/icons/royalty/icon-physical.svg"
                class="dt-icon v5 s2"
                alt="Physical"
                title="Physical"
                :style="{
                  opacity:
                    item['royalty_types'] &&
                    item['royalty_types'].split(',').includes('physical')
                      ? '1'
                      : '0.2',
                }"
              />

              <img
                src="static/icons/royalty/icon-thirdparty.svg"
                class="dt-icon v5 s2"
                alt="Third Party"
                title="Third Party"
                :style="{
                  opacity:
                    item['royalty_types'] &&
                    item['royalty_types'].split(',').includes('thirdparty')
                      ? '1'
                      : '0.2',
                }"
              />

              <img
                src="static/icons/royalty/icon-licensing.svg"
                class="dt-icon v5 s2"
                alt="Licensing"
                title="Licensing"
                :style="{
                  opacity:
                    item['royalty_types'] &&
                    item['royalty_types'].split(',').includes('licensing')
                      ? '1'
                      : '0.2',
                }"
              />

              <img
                src="static/icons/royalty/icon-performance.svg"
                class="dt-icon v5 s2"
                alt="Performance"
                title="Performance"
                :style="{
                  opacity:
                    item['royalty_types'] &&
                    item['royalty_types'].split(',').includes('performance')
                      ? '1'
                      : '0.2',
                }"
              />
            </div>
          </td>
          
          <td v-bind="tdcon('cross_collect')">
            <div style="align-items: center;" class="ut-rowcen">
              <div class="dt-checkbox v2 s1">
                <input
                  type="checkbox"
                  :name="`${item['cross_collectable']}`"
                  :id="`${item['cross_collectable']}`"
                  :checked="`${item['cross_collectable']}` === '1'"
                  @click="(e) => onContractCollectable(e, item)"
                />
                <div class="checkmark"></div>
              </div>
              <TextField2
              style="width: 100px;"
                :id="'cross_collect_key'"
                :type="'text'"
                :showLabel="false"
                :disabled="item['disabled']"
                :value="item['cross_collect_key']"
                @blur="(e) => onTextFieldValueChange(e, item)"
                :bb="'0px'"
              />
            </div>
          </td>
        </tr>
      </template>
    </NTable>
  </DBox>
</template>

<script>
import DBox from "@dtplugins/dbox/dbox";
import NTable from "@/plugins/datatable/datatable";
import {
  createNTableConfig,
  createTableHeader,
} from "../../../../plugins/datatable";
import { RoyaltyStoreNamespace as storeNS } from "../../store";
import * as ActionTypes from "../../store/types";
import { mapActionObject, mapGetterObject } from "../../../../store/global";
import { accountsRoyaltyActions } from "../../store/accounts/actions";
import { AccountsService } from "../../services/accounts.service";

export default {
  components: {
    DBox,
    NTable,
  },
  props: ["selectedAccountDetails"],
  data: () => ({
      tableConfig: createNTableConfig({
        headerStyle: 3,
        fullHeight: true,
      }),
    }),
  computed: {
    list: function () {
      return this.selectedAccountDetails.contracts || [];
    },
    headers: () => [
        createTableHeader("contract_name", {
          text: "Contracts",
          f: 0.5,
          minw: 400,
        }),
        createTableHeader("royalties",{
          ta: "center  ",
          mw: 100,
          minw: 100,
        }),
        createTableHeader("catalog_no"),
        createTableHeader("royalty_types", {
          ta: "center  ",
          mw: 180,
          minw: 180,
        }),
        createTableHeader("cross_collect", {
          ta: "center  ",
          mw: 50,
          minw: 150,
        }),
      ],
  },
  methods: {
    ...mapActionObject(storeNS, accountsRoyaltyActions),
    menuClick: function (menu) {
      this.$emit("add_click", menu);
    },
    onTextFieldValueChange: function ({ name, value }, item) {
      this.$emit("changed", {
        name,
        value,
        kVal: item.contract_id,
        table: "l_contracts",
      });
      // this.updateData(item);
    },
    onContractCollectable: function (e, item) {
      const value = e.target.checked ? "1" : "0";
      // item["cross_collectable"] = value;
      this.$emit("changed", {
        name: "cross_collectable",
        value,
        kVal: item.contract_id,
        table: "l_contracts",
      });
      // this.updateData(item);
    },
    // updateData: function (item) {
    //   const contracts = this.selectedAccountDetails.contracts.map((c) => {
    //     if (c.contract_id === item.contract_id) {
    //       c = {
    //         ...item,
    //       };
    //     }
    //     return c;
    //   });

    //   this[ActionTypes.RoyaltyAccountsContracts.SET.ALL]({
    //     royalty_account_id:
    //       this.selectedAccountDetails?.account?.royalty_account_id,
    //     contracts: contracts || [],
    //   });
    // },
    onSelectContract: function (selectedContract) {
      this.$emit("selected", selectedContract.contract_id);
    },
  },
};
</script>

<style lang="scss">
.cmp-royalty-royalty_accounts-sidewindow-contract_list {
  .contract_name div {
    flex: 1;
    display: flex;
    align-items: center;
    .contact_status {
      display: flex;
      align-items: center;
      // max-width: 150px;
      .circle-status {
        margin-right: 10px;
        //border: 1px solid rgb(168, 168, 168);
      }
      .status-name {
        flex: 1;
      }
    }
  }
}
</style>
